import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "24px",
    height: "24px",
    "aria-hidden": "true",
    viewBox: "0 0 256 256"
  }, props),
  /* @__PURE__ */ React.createElement(
    "g",
    {
      style: {
        stroke: "none",
        strokeWidth: 0,
        strokeDasharray: "none",
        strokeLinecap: "butt",
        strokeLinejoin: "miter",
        strokeMiterlimit: 10,
        fill: "none",
        fillRule: "nonzero",
        opacity: 1
      }
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M87.461 30.127H56.794c4.382 3.475 7.203 8.833 7.208 14.86a19 19 0 0 1-2.544 9.508c-.29.498-.607.974-.937 1.439L41.545 89.846c1.15.095 2.302.158 3.457.154C69.845 89.979 89.979 69.845 90 45.002a44.4 44.4 0 0 0-2.539-14.875",
        style: {
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#ffcd42",
          fillRule: "nonzero",
          opacity: 1
        },
        transform: "translate(1.407 1.407)scale(2.81)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M44.937 63.987c-3.31 0-6.562-.873-9.428-2.529a19.06 19.06 0 0 1-6.96-6.964 19 19 0 0 1-.997-2.014L8.136 19.251A44.96 44.96 0 0 0 .359 39.37c-3.025 23.942 13.367 45.858 36.903 49.939L52.24 62.543a19.1 19.1 0 0 1-7.303 1.444",
        style: {
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#19a15f",
          fillRule: "nonzero",
          opacity: 1
        },
        transform: "translate(1.407 1.407)scale(2.81)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M35.498 28.56a19 19 0 0 1 11.542-2.433h38.774A44.95 44.95 0 0 0 72.499 9.386C53.412-5.361 26.226-2.366 10.764 15.821l15.453 26.447c.813-5.549 4.048-10.687 9.281-13.708",
        style: {
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#dd5044",
          fillRule: "nonzero",
          opacity: 1
        },
        transform: "translate(1.407 1.407)scale(2.81)"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M31.826 37.408C27.632 44.68 30.127 53.976 37.4 58.17s16.569 1.699 20.763-5.574c4.194-7.265 1.705-16.554-5.559-20.748a15.2 15.2 0 0 0-7.563-2.035h-.004a15.15 15.15 0 0 0-13.211 7.595",
        style: {
          stroke: "none",
          strokeWidth: 1,
          strokeDasharray: "none",
          strokeLinecap: "butt",
          strokeLinejoin: "miter",
          strokeMiterlimit: 10,
          fill: "#4b8bf4",
          fillRule: "nonzero",
          opacity: 1
        },
        transform: "translate(1.407 1.407)scale(2.81)"
      }
    )
  )
);
var SvgChromeColoredFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChromeColoredFilled_default = SvgChromeColoredFilled;

export { ChromeColoredFilled_default as default };
